import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';

const ChangePasswordModal = ({ visible, onHide }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChangePassword = async () => {
        if (newPassword !== confirmPassword) {
            toast.error('As senhas não coincidem.');
            return;
        }

        setLoading(true);

        try {
            // Simulate API call for changing password
            await new Promise(resolve => setTimeout(resolve, 1000));
            toast.success('Senha alterada com sucesso!');
            onHide();
        } catch (error) {
            toast.error('Erro ao alterar senha.');
        } finally {
            setLoading(false);
        }
    };

    const renderFooter = () => (
        <div>
            <Button label="Cancelar" onClick={onHide} className="btn inline-link" />
            <Button label="Confirmar" onClick={handleChangePassword} className="btn btn-fill" loading={loading} />
        </div>
    );

    return (
        <Dialog
            header="Mudar Password"
            visible={visible}
            style={{ width: '400px' }}
            footer={renderFooter()}
            onHide={onHide}
        >
            <div className="flex-column gap-s">
                <fieldset>
                    <label htmlFor="currentPassword">Password Atual</label>
                    <InputText
                        id="currentPassword"
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                </fieldset>
                <fieldset>
                    <label htmlFor="newPassword">Nova Password</label>
                    <InputText
                        id="newPassword"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                </fieldset>
                <fieldset>
                    <label htmlFor="confirmPassword">Confirmar Nova Password</label>
                    <InputText
                        id="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </fieldset>
            </div>
        </Dialog>
    );
};

export default ChangePasswordModal;